import { SwitchProps as MuiSwitchProps } from '@mui/material/Switch/Switch';
import { OverridableStringUnion } from '@mui/types';
import { forwardRef } from 'react';
import MuiSwitch, { SwitchPropsColorOverrides } from '@mui/material/Switch';

declare module '@mui/material/Switch' {
  interface SwitchPropsColorOverrides {
    internal: true;
  }
}

type SwitchColor = 'primary' | 'secondary' | 'success' | 'error' | 'warning' | 'info' | 'internal';

export interface SwitchProps extends MuiSwitchProps {
  color?: OverridableStringUnion<SwitchColor, SwitchPropsColorOverrides>;
}

const Switch = forwardRef<HTMLButtonElement, SwitchProps>((props, ref) => {
  return <MuiSwitch ref={ref} {...props} />;
});

Switch.displayName = 'Switch';
export default Switch;
